import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconChevronExpand: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faChevronDown} />;
};
